import axios from "axios";
import { toast } from "react-toastify";

const PersonService = {
  getPerson: async (personUuid) => {
    const token = localStorage.getItem("user-token");

    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: process.env.REACT_APP_DELEND_API+ "/person/" + personUuid,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        toast.error(error.response.data.errorDescription);
      });
  },

  getPersonConsent: async (personUuid) => {
    const token = localStorage.getItem("user-token");

    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url:
        process.env.REACT_APP_DELEND_API +
        "/connections?personUuid=" +
        personUuid,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        toast.error(error.response.data.error);
      });
  },
};

export default PersonService;
